(function () {
  if (window.__swxTheme) return;
  window.__swxTheme = 1;
  var fine = window.matchMedia && window.matchMedia('(pointer:fine)').matches;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  function tilt(el, host, max, lift) {
    if (el.__swxTilt) return;
    el.__swxTilt = 1;
    var glare = document.createElement('i');
    glare.className = 'swx-glare';
    host.appendChild(glare);
    var raf = 0;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        el.style.transition = 'transform .08s linear';
        el.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * max).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * max * 1.2).toFixed(2) + 'deg) translateY(' + lift + 'px)';
        glare.style.setProperty('--mx', (x * 100) + '%');
        glare.style.setProperty('--my', (y * 100) + '%');
      });
    });
    el.addEventListener('pointerleave', function () {
      cancelAnimationFrame(raf);
      el.style.transition = '';
      el.style.transform = '';
    });
  }

  function faq() {
    document.querySelectorAll('[data-swx-faq]:not([data-done])').forEach(function (box) {
      box.setAttribute('data-done', '1');
      var nodes = Array.prototype.slice.call(box.querySelectorAll('p'));
      var pairs = [], cur = null;
      nodes.forEach(function (p) {
        var t = p.textContent.trim();
        if (/^Q\s*[:.)-]/i.test(t)) { cur = { q: t.replace(/^Q\s*[:.)-]\s*/i, ''), a: [] }; pairs.push(cur); }
        else if (cur) { cur.a.push(t.replace(/^A\s*[:.)-]\s*/i, '')); }
      });
      if (!pairs.length) return;
      box.innerHTML = '';
      pairs.forEach(function (pr, i) {
        var d = document.createElement('details');
        d.className = 'swc-acc';
        if (i === 0) d.open = true;
        var s = document.createElement('summary'); s.textContent = pr.q;
        var a = document.createElement('div'); a.className = 'swc-acc__a'; a.textContent = pr.a.join(' ');
        d.appendChild(s); d.appendChild(a); box.appendChild(d);
      });
    });
  }

  function init() {
    faq();
    if (!fine || reduce) return;
    document.querySelectorAll('.card-wrapper').forEach(function (w) {
      var inner = w.querySelector('.card__inner');
      if (inner) tilt(w, inner, 6, -8);
    });
    document.querySelectorAll('.product__media-item').forEach(function (m) { tilt(m, m, 3, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(function () { clearTimeout(init.t); init.t = setTimeout(init, 200); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
